(function ($) {
  'use strict';

  var joinFundraiserBusy = false;
  var joinFundraiserAlertTimer = null;
  var JOIN_FUNDRAISER_ALERT_DURATION = 5000;
  var teamStoreCount = 0;
  var initialized = false;

  function getCustomerId() {
    return window.FundraisingApi ? window.FundraisingApi.getCustomerId() : window.customerId;
  }

  function getJoinFundraiserInfoKey() {
    return 'joinFundraiserInfoSeen_' + (getCustomerId() || 'guest');
  }

  function hideJoinFundraiserAlert() {
    var $alert = $('.join-fundraiser-alert');
    var $bar = $alert.find('.join-fundraiser-alert__progress-bar');

    if (joinFundraiserAlertTimer) {
      clearTimeout(joinFundraiserAlertTimer);
      joinFundraiserAlertTimer = null;
    }

    $bar.removeClass('is-animating');
    $alert
      .addClass('is-hidden')
      .removeClass('join-fundraiser-alert--persistent join-fundraiser-alert--timed');
  }

  function markJoinFundraiserInfoSeen() {
    try {
      localStorage.setItem(getJoinFundraiserInfoKey(), '1');
    } catch (e) {
      /* ignore storage errors */
    }
  }

  function hasSeenJoinFundraiserInfo() {
    try {
      return localStorage.getItem(getJoinFundraiserInfoKey()) === '1';
    } catch (e) {
      return false;
    }
  }

  function startJoinFundraiserTimedAlert() {
    var $alert = $('.join-fundraiser-alert');
    var $bar = $alert.find('.join-fundraiser-alert__progress-bar');

    hideJoinFundraiserAlert();

    $alert
      .removeClass('is-hidden join-fundraiser-alert--persistent')
      .addClass('join-fundraiser-alert--timed');

    $bar.removeClass('is-animating');
    void $bar[0].offsetWidth;
    $bar.addClass('is-animating');

    if (joinFundraiserAlertTimer) {
      clearTimeout(joinFundraiserAlertTimer);
    }

    joinFundraiserAlertTimer = setTimeout(function () {
      hideJoinFundraiserAlert();
      markJoinFundraiserInfoSeen();
    }, JOIN_FUNDRAISER_ALERT_DURATION);
  }

  function showJoinFundraiserPersistentAlert() {
    hideJoinFundraiserAlert();
    $('.join-fundraiser-alert')
      .removeClass('is-hidden join-fundraiser-alert--timed')
      .addClass('join-fundraiser-alert--persistent');
  }

  function updateJoinFundraiserAlert() {
    if (teamStoreCount === 0) {
      showJoinFundraiserPersistentAlert();
    } else if (teamStoreCount > 0 && !hasSeenJoinFundraiserInfo()) {
      startJoinFundraiserTimedAlert();
    } else {
      hideJoinFundraiserAlert();
    }
  }

  function closeNewStoreModal() {
    hideJoinFundraiserAlert();
    $('#newStore').fadeOut();
    $('body').removeClass('hide_scroll');
  }

  function bindEvents() {
    $(document).on('click', '#new-store', function () {
      updateJoinFundraiserAlert();
      $('#newStore').fadeIn();
      $('body').addClass('hide_scroll');
    });

    $(document).on('click', '#newStore .close', function () {
      closeNewStoreModal();
    });

    $(document).on('click', '#newStore', function (event) {
      if ($(event.target).is('#newStore')) {
        closeNewStoreModal();
      }
    });

    $(document).on('click', '.join-fundraiser-alert__close', function () {
      hideJoinFundraiserAlert();
      if (teamStoreCount > 0) {
        markJoinFundraiserInfoSeen();
      }
    });

    $(document).on('input', '#newStoreinput', function () {
      var campaignCode = $(this).val().trim();
      var baseUrl = '/pages/virtual-stores';
      var newUrl = campaignCode ? baseUrl + '?cc=' + encodeURIComponent(campaignCode) : baseUrl;

      $('#continueButton').attr('href', newUrl);

      if (campaignCode) {
        $('#continueButton').removeClass('disabled');
      } else {
        $('#continueButton').addClass('disabled');
        $('.code_error').text('');
      }
    });

    $(document).on('click', '#continueButton', function (e) {
      e.preventDefault();

      if ($(this).hasClass('disabled') || joinFundraiserBusy) return;

      var campaignCode = $('#newStoreinput').val().trim();
      var joinCustomerId = getCustomerId();

      if (campaignCode === '') {
        $('.code_error').text('Please enter an organization code.');
        return;
      }

      if (!joinCustomerId) {
        if (window.FundraisingApi) {
          window.FundraisingApi.saveCampaignCode(campaignCode);
        }
        var returnPath = '/pages/virtual-stores';
        window.location.href =
          '/account/login?return_to=' +
          encodeURIComponent(returnPath) +
          '&cc=' +
          encodeURIComponent(campaignCode);
        return;
      }

      joinFundraiserBusy = true;
      $('.code_error').text('');
      var $btn = $(this);
      var btnLabel = $btn.text();
      $btn.addClass('disabled').text('Checking…');

      var searchOptions = {
        url: apiUrl + 'api/search-campaign?campaignCode=' + encodeURIComponent(campaignCode) + '&customerId=' + encodeURIComponent(joinCustomerId),
        method: 'GET',
        contentType: false,
        mode: 'cors'
      };

      function onJoinSuccess(response) {
        joinFundraiserBusy = false;
        $btn.removeClass('disabled').text(btnLabel);

        var campaign = window.FundraisingApi
          ? window.FundraisingApi.parseSearchCampaignResponse(response)
          : (response.data && (response.data.campaign || response.data.data));

        if (!campaign) {
          var errMsg = window.FundraisingApi
            ? window.FundraisingApi.getSearchCampaignError(response)
            : ((response.data && response.data.error) || 'Invalid organization code.');
          $('.code_error').text(errMsg);
          return;
        }

        if (window.FundraisingApi) {
          window.FundraisingApi.saveCampaignCode(campaignCode);
        }
        window.location.href = '/pages/virtual-stores?cc=' + encodeURIComponent(campaignCode);
      }

      function onJoinError(xhr) {
        joinFundraiserBusy = false;
        $btn.removeClass('disabled').text(btnLabel);
        var msg = window.FundraisingApi
          ? window.FundraisingApi.getApiErrorMessage(xhr, 'An error occurred while processing your request.')
          : ((xhr.responseJSON && xhr.responseJSON.message) || 'An error occurred while processing your request.');
        $('.code_error').text(msg);
      }

      if (window.FundraisingApi && window.FundraisingApi.ajaxGetWithRetry) {
        window.FundraisingApi.ajaxGetWithRetry(searchOptions, 2, onJoinSuccess, onJoinError);
      } else {
        $.ajax(searchOptions).done(onJoinSuccess).fail(onJoinError);
      }
    });
  }

  window.NewStoreModal = {
    init: function (options) {
      if (!$('#newStore').length || initialized) return;
      initialized = true;

      options = options || {};
      if (options.teamStoreCount != null) {
        teamStoreCount = options.teamStoreCount;
      }

      bindEvents();
    },
    setTeamStoreCount: function (count) {
      teamStoreCount = count;
    }
  };

  $(function () {
    if ($('#newStore').length) {
      window.NewStoreModal.init({ teamStoreCount: 0 });
    }
  });
})(jQuery);
